import { render, staticRenderFns } from "./WebhookInfo.vue?vue&type=template&id=54d05e2e"
import script from "./WebhookInfo.vue?vue&type=script&lang=js"
export * from "./WebhookInfo.vue?vue&type=script&lang=js"
import style0 from "./WebhookInfo.vue?vue&type=style&index=0&id=54d05e2e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports